export default {"src":"/_next/static/media/science.43edab17.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};